<div class="treino-container">

  <!-- HEADER -->
  <div class="row align-items-center mb-2">
    <div class="col-7 col-md-10">
      <h2 class="mb-0">Gestão de Treino</h2>
    </div>

    <div class="col-5 col-md-2 text-end">
      <button class="btn btn-sm btn-primary w-100 w-md-auto" (click)="openTreinoModal()">
        Novo
      </button>
    </div>
  </div>

  <!-- 🔥 DESKTOP -->
  <ng-container *ngIf="!isMobile">

    <table mat-table [dataSource]="dataSource" matSort class="mt-2 w-100">
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef class="d-none">Id</th>
        <td mat-cell *matCellDef="let element" class="d-none">
          {{element.id}}
        </td>
      </ng-container>
      <ng-container matColumnDef="nome">
        <th mat-header-cell *matHeaderCellDef>Nome</th>
        <td mat-cell *matCellDef="let element">{{element.nome}}</td>
      </ng-container>

      <ng-container matColumnDef="diaSemana">
        <th mat-header-cell *matHeaderCellDef>Dia</th>
        <td mat-cell *matCellDef="let element">
          {{
          element.diaSemana === 0 ? 'Domingo' :
          element.diaSemana === 1 ? 'Segunda' :
          element.diaSemana === 2 ? 'Terça' :
          element.diaSemana === 3 ? 'Quarta' :
          element.diaSemana === 4 ? 'Quinta' :
          element.diaSemana === 5 ? 'Sexta' :
          element.diaSemana === 6 ? 'Sábado' : 'Outro'
          }}
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row">

          <div class="d-flex flex-wrap gap-1">

            <!-- EDITAR -->
            <button class="btn btn-sm btn-light" (click)="openTreinoModal(row)">
              <i class="bi bi-pen-fill"></i>
            </button>

            <!-- REMOVER -->
            <button class="btn btn-sm btn-light" (click)="remover(row.id)">
              <i class="bi bi-trash"></i>
            </button>

            <!-- EXERCÍCIO -->
            <button class="btn btn-sm btn-outline-dark d-flex align-items-center gap-1"
              (click)="openModalItens(row.id, 'exercicio')">
              <fa-icon [icon]="faDumbbell"></fa-icon>
              <span class="d-none d-md-inline">Exercícios</span>
            </button>

            <!-- ABDOMINAL -->
            <button class="btn btn-sm btn-outline-dark d-flex align-items-center gap-1"
              (click)="openModalItens(row.id, 'abdominal')">

              <svg width="16" height="16" viewBox="0 0 48 48" fill="none">
                <path d="M7.9 5C10.7 8 12.1 11.9 12.1 16.7C12.1 24 6 29.5 5 33.5C4.3 36.1 4 39.3 4 43"
                  stroke="currentColor" stroke-width="3" stroke-linecap="round" />
                <path d="M39.2 5C36.4 8 35 11.9 35 16.7C35 24 41.1 29.5 42.1 33.5C42.8 36.1 43.1 39.3 43 43"
                  stroke="currentColor" stroke-width="3" stroke-linecap="round" />
                <path d="M6.2 30.8C12.7 35 18.7 37 24 37C29.3 37 35 35 40.9 30.8" stroke="currentColor" stroke-width="3"
                  stroke-linecap="round" />
                <line x1="24" y1="12" x2="24" y2="34" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                <line x1="18" y1="16" x2="30" y2="16" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                <line x1="18" y1="22" x2="30" y2="22" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                <line x1="18" y1="28" x2="30" y2="28" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
              </svg>

              <span class="d-none d-md-inline">Abd</span>
            </button>

            <!-- CARDIO -->
            <button class="btn btn-sm btn-outline-dark d-flex align-items-center gap-1"
              (click)="openModalItens(row.id, 'cardio')">
              <fa-icon [icon]="faCardio"></fa-icon>
              <span class="d-none d-md-inline">Cardio</span>
            </button>


          </div>

        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    </table>

    <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons>
    </mat-paginator>

  </ng-container>

  <!-- 🔥 MOBILE -->
  <ng-container *ngIf="isMobile">

    <div class="card mb-2" *ngFor="let row of dataSource.data">

      <div class="card-body p-2">

        <div class="fw-bold">
          {{ row.nome }}
        </div>

        <div class="text-muted small mb-2">
          {{
          row.diaSemana === 0 ? 'Domingo' :
          row.diaSemana === 1 ? 'Segunda' :
          row.diaSemana === 2 ? 'Terça' :
          row.diaSemana === 3 ? 'Quarta' :
          row.diaSemana === 4 ? 'Quinta' :
          row.diaSemana === 5 ? 'Sexta' :
          row.diaSemana === 6 ? 'Sábado' : 'Outro'
          }}
        </div>

        <div class="d-grid gap-1">

          <button class="btn btn-sm btn-outline-primary" (click)="openTreinoModal(row)">
            <i class="bi bi-pen-fill"></i> Editar
          </button>

          <button class="btn btn-sm btn-outline-danger" (click)="remover(row.id)">
            <i class="bi bi-trash"></i> Remover
          </button>

          <button class="btn btn-sm btn-outline-dark" (click)="openModalItens(row.id, 'exercicio')">
            <fa-icon [icon]="faDumbbell"></fa-icon> Exercícios
          </button>

          <button class="btn btn-sm btn-outline-dark" (click)="openModalItens(row.id, 'abdominal')">
            <svg width="16" height="16" viewBox="0 0 48 48" fill="none">
                <path d="M7.9 5C10.7 8 12.1 11.9 12.1 16.7C12.1 24 6 29.5 5 33.5C4.3 36.1 4 39.3 4 43"
                  stroke="currentColor" stroke-width="3" stroke-linecap="round" />
                <path d="M39.2 5C36.4 8 35 11.9 35 16.7C35 24 41.1 29.5 42.1 33.5C42.8 36.1 43.1 39.3 43 43"
                  stroke="currentColor" stroke-width="3" stroke-linecap="round" />
                <path d="M6.2 30.8C12.7 35 18.7 37 24 37C29.3 37 35 35 40.9 30.8" stroke="currentColor" stroke-width="3"
                  stroke-linecap="round" />
                <line x1="24" y1="12" x2="24" y2="34" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                <line x1="18" y1="16" x2="30" y2="16" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                <line x1="18" y1="22" x2="30" y2="22" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                <line x1="18" y1="28" x2="30" y2="28" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
              </svg> Abdominais
          </button>

          <button class="btn btn-sm btn-outline-dark" (click)="openModalItens(row.id, 'cardio')">
            <fa-icon [icon]="faCardio"></fa-icon> Cardio
          </button>

        </div>

      </div>

    </div>

    <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons>
    </mat-paginator>

  </ng-container>

</div>